import { defineComponent as _defineComponent } from 'vue';
import { storeToRefs } from "pinia";
import { ref } from "vue";
import { useHistoryStore } from "@/stores/historyStore";
import { useUserStore } from "@/stores/userStore";
import CurrentCollection from "@/components/History/CurrentCollection/CollectionPanel.vue";
import HistoryNavigation from "@/components/History/CurrentHistory/HistoryNavigation.vue";
import HistoryPanel from "@/components/History/CurrentHistory/HistoryPanel.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Index',
    setup(__props) {
        const userStore = useUserStore();
        const historyStore = useHistoryStore();
        const { currentUser } = storeToRefs(userStore);
        const { currentHistory, histories, historiesLoading } = storeToRefs(historyStore);
        const listOffset = ref(0);
        const breadcrumbs = ref([]);
        function onViewCollection(collection, currentOffset) {
            listOffset.value = currentOffset;
            breadcrumbs.value = [...breadcrumbs.value, collection];
        }
        return { __sfc: true, userStore, historyStore, currentUser, currentHistory, histories, historiesLoading, listOffset, breadcrumbs, onViewCollection, CurrentCollection, HistoryNavigation, HistoryPanel };
    }
});
